import { render, staticRenderFns } from "./BasicsShelf.vue?vue&type=template&id=21eeb50c&scoped=true"
import script from "./BasicsShelf.vue?vue&type=script&lang=js"
export * from "./BasicsShelf.vue?vue&type=script&lang=js"
import style0 from "./BasicsShelf.vue?vue&type=style&index=0&id=21eeb50c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21eeb50c",
  null
  
)

export default component.exports